// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-list-item {
  width: 133px;
  /* height: 192px; */
  float: left;
  overflow: hidden;
  position: relative;
}
.book-item-cover {
  width: 105px;
  /* height: 137px; */
  opacity: 1;
  margin: 10px 15px 5px 15px;
  cursor: pointer;
  /* overflow: hidden; */
  display: flex;
  justify-content: center;

  border-radius: 2px;
}
.book-item-image {
  border-radius: 2px;
}
.book-item-title {
  width: 80%;
  margin-left: 10%;
  /* margin-bottom: 5px; */
  height: 31px;
  font-size: 12px;
  line-height: 15px;
  opacity: 1;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  position: relative;
}
.book-selected-icon {
  opacity: 0.5;
}
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.book-more-action {
  /* position: absolute;
  bottom: 23px;
  right: 17px; */
  transform: rotate(90deg);
  float: right;
  font-size: 14px;
  cursor: pointer;
  margin-right: 14px;
  margin-top: 4px;
  opacity: 0.8;
}
.book-heart-action {
  /* position: absolute;
  bottom: 23px;
  right: 17px; */
  float: right;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 6px;
  margin-top: 4px;
  opacity: 0.8;
  color: rgb(231, 69, 69);
}
.book-download-action {
  /* position: absolute;
  bottom: 23px;
  right: 40px; */
  font-size: 15px;
  margin-right: 2px;
  margin-left: 2px;
  position: relative;
  top: 2px;
}
.reading-progress-icon {
  /* position: absolute;
  bottom: 18px;
  left: 17px; */
  /* width: 31px;
  height: 31px; */
  display: inline-block;
  margin-left: 10px;
  border-radius: 50%;
  font-size: 12px;
  /* line-height: 31px; */
  cursor: pointer;
}
@keyframes slide-down {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-down-rotate {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes slide-up {
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
.reading-percentage-char {
  display: inline-block;
  transform: scale(0.5) translate(-5px, 2px);
}
.book-love-icon {
  position: absolute;
  bottom: 25px;
  right: 20px;
  font-size: 18px;
  cursor: pointer;
  z-index: 1;
}
.book-loved-icon {
  position: absolute;
  bottom: 23px;
  right: 19px;
  font-size: 20px;
  color: #f87356;
  cursor: pointer;
  z-index: 2;
}
.book-selected-icon {
  position: absolute;
  bottom: 60px;
  right: 21px;
  font-size: 20px;
  color: #f87356;
  cursor: pointer;
  z-index: 2;
}

.action-dialog-parent {
  position: fixed;
  top: 0px;
  left: 200px;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./src/components/bookCardItem/bookCardItem.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,uBAAuB;;EAEvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;AACA;EACE;;gBAEc;EACd,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE;;gBAEc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE;;gBAEc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE;;eAEa;EACb;iBACe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,WAAW;AACb","sourcesContent":[".book-list-item {\n  width: 133px;\n  /* height: 192px; */\n  float: left;\n  overflow: hidden;\n  position: relative;\n}\n.book-item-cover {\n  width: 105px;\n  /* height: 137px; */\n  opacity: 1;\n  margin: 10px 15px 5px 15px;\n  cursor: pointer;\n  /* overflow: hidden; */\n  display: flex;\n  justify-content: center;\n\n  border-radius: 2px;\n}\n.book-item-image {\n  border-radius: 2px;\n}\n.book-item-title {\n  width: 80%;\n  margin-left: 10%;\n  /* margin-bottom: 5px; */\n  height: 31px;\n  font-size: 12px;\n  line-height: 15px;\n  opacity: 1;\n  text-align: left;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  position: relative;\n}\n.book-selected-icon {\n  opacity: 0.5;\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n.book-more-action {\n  /* position: absolute;\n  bottom: 23px;\n  right: 17px; */\n  transform: rotate(90deg);\n  float: right;\n  font-size: 14px;\n  cursor: pointer;\n  margin-right: 14px;\n  margin-top: 4px;\n  opacity: 0.8;\n}\n.book-heart-action {\n  /* position: absolute;\n  bottom: 23px;\n  right: 17px; */\n  float: right;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-right: 6px;\n  margin-top: 4px;\n  opacity: 0.8;\n  color: rgb(231, 69, 69);\n}\n.book-download-action {\n  /* position: absolute;\n  bottom: 23px;\n  right: 40px; */\n  font-size: 15px;\n  margin-right: 2px;\n  margin-left: 2px;\n  position: relative;\n  top: 2px;\n}\n.reading-progress-icon {\n  /* position: absolute;\n  bottom: 18px;\n  left: 17px; */\n  /* width: 31px;\n  height: 31px; */\n  display: inline-block;\n  margin-left: 10px;\n  border-radius: 50%;\n  font-size: 12px;\n  /* line-height: 31px; */\n  cursor: pointer;\n}\n@keyframes slide-down {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n@keyframes slide-down-rotate {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n@keyframes slide-up {\n  0% {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0px);\n    opacity: 1;\n  }\n}\n.reading-percentage-char {\n  display: inline-block;\n  transform: scale(0.5) translate(-5px, 2px);\n}\n.book-love-icon {\n  position: absolute;\n  bottom: 25px;\n  right: 20px;\n  font-size: 18px;\n  cursor: pointer;\n  z-index: 1;\n}\n.book-loved-icon {\n  position: absolute;\n  bottom: 23px;\n  right: 19px;\n  font-size: 20px;\n  color: #f87356;\n  cursor: pointer;\n  z-index: 2;\n}\n.book-selected-icon {\n  position: absolute;\n  bottom: 60px;\n  right: 21px;\n  font-size: 20px;\n  color: #f87356;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.action-dialog-parent {\n  position: fixed;\n  top: 0px;\n  left: 200px;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
